import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/apiClient";
import { toast } from "sonner";
import { Loader2, Users, Check, X } from "lucide-react";

export default function InviteAccept() {
  const { token } = useParams();
  const { fetchIdentity } = useAuth();
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/invitations/lookup/${token}`).then((r) => setInv(r.data)).catch((e) => setErr(e.response?.data?.detail || "Invitation introuvable."));
  }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/invitations/${token}/accept`);
      toast.success(`Tu es désormais accompagné par ${data.manager_name || "ton manager"} 🎉`);
      fetchIdentity();
      navigate("/dashboard");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Impossible d'accepter.");
      setBusy(false);
    }
  };

  const decline = async () => {
    setBusy(true);
    try { await api.post(`/invitations/${token}/decline`); } catch {}
    toast("Invitation refusée.");
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-zinc-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#18181E] border border-zinc-800 rounded-3xl p-8 text-center" data-testid="invite-accept">
        {err ? (
          <>
            <X className="w-10 h-10 text-red-400 mx-auto mb-3" />
            <p className="text-zinc-300">{err}</p>
            <button onClick={() => navigate("/dashboard")} className="mt-5 h-11 px-5 rounded-xl bg-zinc-900 border border-zinc-800 text-sm">Retour</button>
          </>
        ) : !inv ? (
          <Loader2 className="w-8 h-8 text-amber-500 animate-spin mx-auto" />
        ) : inv.status !== "PENDING" ? (
          <>
            <p className="text-zinc-300">Cette invitation a déjà été traitée ({inv.status}).</p>
            <button onClick={() => navigate("/dashboard")} className="mt-5 h-11 px-5 rounded-xl bg-zinc-900 border border-zinc-800 text-sm">Retour</button>
          </>
        ) : (
          <>
            <div className="w-14 h-14 rounded-2xl gold-gradient flex items-center justify-center mx-auto mb-4 glow-gold"><Users className="w-7 h-7 text-black" /></div>
            <h1 className="font-display text-2xl font-extrabold">Invitation Manager</h1>
            <p className="text-zinc-400 text-sm mt-2"><span className="text-amber-400 font-semibold">{inv.manager_name}</span> souhaite t'accompagner sur Cehnura.</p>
            <p className="text-xs text-zinc-600 mt-2">Il aura un accès en lecture seule (profil, projets, progression, statistiques). Tu restes propriétaire de tes données.</p>
            <div className="flex gap-3 mt-6">
              <button onClick={decline} disabled={busy} data-testid="invite-decline-btn" className="flex-1 h-12 rounded-xl bg-zinc-900 border border-zinc-800 text-zinc-300 text-sm">Refuser</button>
              <button onClick={accept} disabled={busy} data-testid="invite-accept-btn" className="flex-1 h-12 rounded-xl gold-gradient text-black font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-60">
                {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Check className="w-5 h-5" />} Accepter
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
